import React, { useMemo } from "react"
import { Col, Flex, Form, Input, List, Row } from "antd"
import { useForm } from "antd/es/form/Form"
import { format } from "date-fns"

import { authStore } from "@src/app/authStore"
import { LoadingBlock } from "@src/app/components/LoadingBlock"
import { notify } from "@src/app/components/notify"
import { merchantApi } from "@src/shared/api"
import { SubmitButton } from "@src/shared/componemts/SubmitButton"
import { useCatchFormErrors } from "@src/shared/form/base_error"
import { useResourceLoader } from "@src/shared/resource/resource"
import css from "./index.module.css"

type ChangeEmailStatus = {
  expire_at?: string
  new_email?: string
}
type ChangeEmailStart = {
  email: string
  password: string
}
type ChangeEmailConfirm = {
  code: string
}
type ChangeEmailStartProps = {
  reload: () => void
}
const ChangeEmailStart = ({ reload }: ChangeEmailStartProps) => {
  const [form] = useForm<ChangeEmailStart>()
  const { submit } = useCatchFormErrors(form, (values) =>
    merchantApi.changeEmailStart(values).then(() => reload()),
  )

  return (
    <Form
      form={form}
      id="GENERATED_ID_SETTINGSEMAIL_FORM_VOID_1"
      layout="vertical"
      onFinish={submit}
      size="large"
      style={{ border: "none" }}
    >
      <Flex gap={24} style={{ width: "100%" }} vertical>
        <Row align="top" gutter={24}>
          <Col span={10}>
            <Form.Item
              id="GENERATED_ID_SETTINGSEMAIL_FORM_ITEM_VOID_1"
              label="New e-mail"
              name="email"
            >
              <Input placeholder="Enter e-mail" />
            </Form.Item>
          </Col>

          <Col span={10}>
            <Form.Item
              id="GENERATED_ID_SETTINGSEMAIL_FORM_ITEM_VOID_2"
              label="Current Password"
              name="password"
            >
              <Input placeholder="Enter password" type="password" />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item
              id="GENERATED_ID_SETTINGSEMAIL_FORM_ITEM_VOID_3"
              label={" "}
            >
              <SubmitButton form={form}>Save new email</SubmitButton>
            </Form.Item>
          </Col>
        </Row>
      </Flex>
    </Form>
  )
}

type ChangeEmailConfirmProps = {
  reload: () => void
  status: ChangeEmailStatus
}
const ChangeEmailConfirm = ({ reload, status }: ChangeEmailConfirmProps) => {
  const expireAt = useMemo(
    () => new Date(status.expire_at!),
    [status.expire_at],
  )

  const { reload: authReload } = authStore
  const [form] = useForm<ChangeEmailConfirm>()
  const { submit } = useCatchFormErrors(form, (values) =>
    merchantApi
      .changeEmailConfirm(values)
      .then(authReload)
      .then(() => reload())
      .catch((error) =>
        notify.error(
          error?.response?.data?.error?.message || "Invalid request",
        ),
      ),
  )

  return (
    <div>
      <List>
        <List.Item className={css.item}>
          <div>Expire at</div>
          <div>{format(expireAt, "PPpp")}</div>
        </List.Item>
        <List.Item className={css.item}>
          <div>New email</div>
          <div>{status.new_email}</div>
        </List.Item>
      </List>
      <Form
        className={css.form}
        id="GENERATED_ID_SETTINGSEMAIL_FORM_VOID_2"
        layout="vertical"
        onFinish={submit}
      >
        <Row align="bottom" gutter={24}>
          <Col span={12}>
            <Form.Item
              id="GENERATED_ID_SETTINGSEMAIL_FORM_ITEM_VOID_4"
              label="Confirm code"
              name="code"
            >
              <Input size="large" />
            </Form.Item>
          </Col>
          <Col span={4}>
            <SubmitButton form={form}>Confirm</SubmitButton>
          </Col>
        </Row>
      </Form>
    </div>
  )
}

export const SettingsChangeEmail = () => {
  const { data, isPending, load } = useResourceLoader<
    ChangeEmailStatus | undefined
  >(
    () =>
      merchantApi
        .changeEmailStatus()
        .then((response) => response.data as ChangeEmailStatus),
    [],
  )

  return isPending ? (
    <LoadingBlock />
  ) : (
    <>
      {
        // @ts-ignore
        data?.data?.expire_at ? (
          // @ts-ignore
          <ChangeEmailConfirm reload={load} status={data.data} />
        ) : (
          <ChangeEmailStart reload={load} />
        )
      }
    </>
  )
}
